
import clientAvenyModel from '../../../../../../../../Model/clientAvenyModel';
import { IClientBusinessModel } from '../../../../../../../../Types/ClientModelTypes';
import BusinessDataForm, {
  useBusinessDataFormContext,
} from '../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import { IValidateFn } from '../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import useValidateBokfar from '../../../Hooks/useValidateBokfar';
import { BokforderQuery_node_TEDEKBokforder } from '../../../Queries/_QueryTypes/BokforderQuery';

interface IProps {}

const bokforderModel: IClientBusinessModel =
  clientAvenyModel.EK.BusinessModels.EKBokforder;

const PeriodDialogWrapper: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const validateBokfar = useValidateBokfar();
  const parentFormContext = useBusinessDataFormContext();

  return (
    <BusinessDataForm<BokforderQuery_node_TEDEKBokforder>
      model={bokforderModel}
      validateFns={[validateBokfar as IValidateFn]}
      localValuesInChildForm
      isNew={parentFormContext?.isNew}
    >
      {props.children}
    </BusinessDataForm>
  );
};

export default PeriodDialogWrapper;
